import React from 'react';
import './mbko.css'
import img1 from '../style/list01.png'
import img2 from '../style/list02.png'
import img3 from '../style/list03.png'
import img4 from '../style/list04.png'
import img5 from '../style/list05.png'
import img6 from '../style/list06.png'
import img7 from '../style/list07.png'
import img8 from '../style/list08.png'
import img9 from '../style/list09.png'
import img10 from '../style/list10.png'
import img11 from '../style/list11.png'
import img12 from '../style/title_small.png'
import img13 from '../style/kakao.png'
import { Link } from 'react-router-dom';


function Mbko(props) {
    return (
        <>
            <div className='bg-color'>
                <div className="background-image container container1">
                    <div className="top-image">

                        <div className='logo-image container container1' >
                        </div>
                        <div>
                        <Link to="/mbko/MLG">
                    <img className='btn1' src={img1} width={320}></img>
                    </Link>
                    {/* <p style={{color:'white', marginBottom:8}}>
                    ＜종목 별 상세 규정 및 예선 개최지 정보＞
                    </p>
                    <Link to="/mbko/HOC">
                    <img className='btn2' src={img2} width={320}></img>
                    </Link>
                    <Link to="/mbko/PB_A">
                    <img className='btn2' src={img3} width={320}></img>
                    </Link>
                    <Link to="/mbko/PB_B">
                    <img className='btn2' src={img4} width={320}></img>
                    </Link>
                    <Link to="/mbko/AQU">
                    <img className='btn2' src={img6} width={320}></img>
                    </Link>
                    <Link to="/mbko/GIZ">
                    <img className='btn2' src={img5} width={320}></img>
                    </Link>
                    <Link to="/mbko/BLO">
                    <img className='btn2' src={img7} width={320}></img>
                    </Link>
                    <Link to="/mbko/T2R_A">
                    <img className='btn2' src={img8} width={320}></img>
                    </Link>
                    <Link to="/mbko/T2R_B">
                    <img className='btn2' src={img9} width={320}></img>
                    </Link>
                    <Link to="/mbko/CEN">
                    <img className='btn2' src={img10} width={320}></img>
                    </Link>
                    <Link to="/mbko/MMD">
                    <img className='btn2' src={img11} width={320}></img>
                    </Link> */}
                        </div>
                        <p>
                            </p>
                            <div className='font-small'>
                            <p style={{color:'white', marginBottom:0}}>대회문의 </p>
                            <p style={{color:'white', marginBottom:0}}>☎ KbSF사무국 010-2251-2630</p>
                            <p style={{color:'white', marginBottom:0}}>☎ MbKO운영부 010-3372-4091</p>

                            </div>
                            <div>
                                <a href="http://pf.kakao.com/_GNxeQb/chat">
                                    <img src={img13} width='40px' align='right' style={{marginRight:'50px', marginBottom:'30px'}}></img>
                                    </a>
                            </div>
                            <p></p>                        
                    </div>
                </div>

                <div className='bottom1 container container1'>
                    <div className='bottom container container1'>
                    </div>

                </div>
            </div>
        </>


    );
}

export default Mbko;